/**
 * Date-extensions locale Esperanto [eo]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('eo', {
    monthNames: ['Januaro','Februaro','Marto','Aprilo','Majo','Junio','Julio','Aŭgusto','Septembro','Oktobro','Novembro','Decembro'],
    monthShortNames: ['Jan','Feb','Mar','Apr','Maj','Jun','Jul','Aŭg','Sep','Okt','Nov','Dec'],
    dayNames: ['Dimanĉo','Lundo','Mardo','Merkredo','ĵaŭdo','Vendredo','Sabato'],
    dayShortNames: ['Dim','Lun','Mard','Merk','ĵaŭ','Ven','Sab']
});
